module.exports = __webpack_public_path__ + "img/champagne-colored-icon.ff47fa8e.svg";